module.exports = __webpack_public_path__ + "img/img_案例05.73c53afd.png";